export default "__VITE_ASSET__nugYi2ai__"